import { Icon } from '@rbilabs/universal-components';
import { format, isValid } from 'date-fns';
import { StyleSheet } from 'react-native';

import { Box, Typography } from 'components/ui';
import { CenteredRowContainer } from 'components/ui/centered-row-container';
import { LoyaltyPromotionType } from 'generated/graphql-gateway';
import { t } from 'state/intl/translations';
import { useLoyaltyContext } from 'state/loyalty';
import { primitive } from 'styles/constants';
import { WEB_SMALL_MAX_WIDTH } from 'utils/constants';

export const LoyaltyIncentiveCooldownContent = ({
  incentiveType,
  availableAfter,
}: {
  incentiveType: LoyaltyPromotionType;
  availableAfter?: Date;
}) => {
  const header =
    incentiveType === LoyaltyPromotionType.REWARD
      ? t('rewardsCooldownTitle', 'You just redeemed a reward')
      : t('offersCooldownTitle', 'You just redeemed an offer');

  return (
    <>
      <Icon variant="errorFill" size="14" marginRight="$2" />
      <Box style={styles.cooldownMessageContainer}>
        <Typography variant="headerFour" fontSize="xs" mb="$0">
          {header}
        </Typography>
        <Typography variant="copyTwo" fontSize="xs">
          {availableAfter && isValid(availableAfter)
            ? t('offersAvailableAt', { time: format(availableAfter, 'hh:mm a') })
            : t('offersAvailableAtFallback')}
        </Typography>
      </Box>
    </>
  );
};

export const LoyaltyIncentiveCooldownMessage = ({
  incentiveType,
}: {
  incentiveType: LoyaltyPromotionType;
}) => {
  const { offersCooldown, rewardsCooldown } = useLoyaltyContext();
  const cooldownInfo =
    incentiveType === LoyaltyPromotionType.OFFER ? offersCooldown : rewardsCooldown;

  if (!cooldownInfo.isActive) {
    return null;
  }

  return (
    <Box style={styles.cooldownContainer}>
      <CenteredRowContainer style={styles.containerStyle} standardPadding>
        <LoyaltyIncentiveCooldownContent
          incentiveType={incentiveType}
          availableAfter={cooldownInfo.endsAt}
        />
      </CenteredRowContainer>
    </Box>
  );
};

const styles = StyleSheet.create({
  // LoyaltyOffersCooldownMessage
  cooldownContainer: {
    backgroundColor: primitive.$warningLight,
    paddingVertical: 8,
  },
  containerStyle: { maxWidth: WEB_SMALL_MAX_WIDTH, flexDirection: 'row', alignItems: 'center' },
  // LoyaltyOffersCooldownContent
  cooldownMessageContainer: {
    flexDirection: 'column',
  },
});
